import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  title: {
    color: theme.palette.purple,
    fontSize: "2.5rem",
    textAlign: "center",
    height: "auto",
    maxWidth: "21.375rem",
    paddingBottom: "1.5rem",
    margin: "0 auto",
    [theme.breakpoints.up('md')]: {
      maxWidth: "53.5rem",
      paddingBottom: "2rem",
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: "3.75rem",
    },
  },
  yellow: {
    backgroundColor: theme.palette.yellow,
    padding: "0 1rem",
  },
  yellowBackground: {
    backgroundColor: theme.palette.yellow,
    position: "relative",
  },
}));
